export const HeaderIconHandler = {
  name: "HeaderIconHandler",
  // 获取图片尺寸
  getImgSize (url) {
    return new Promise((resolve, reject) => {
      let imgObj = new Image()
      imgObj.src = url
      imgObj.onload = () => {
        resolve({
          width: imgObj.width,
          height: imgObj.height
        })
      }
    })
  },
  ComputeMarginVertical(w,h,circalSize) {
    let data1 = '-' + ((h/w*circalSize)-circalSize)/2 + 'px 0 0 0';
    return data1
  },
  ComputeMarginHorizontal(w,h,circalSize) {
    let data1 = '0 0 0 -' + ((w/h*circalSize)-circalSize)/2 + 'px';
    return data1
  }
};



// WEBPACK FOOTER //
// ./src/handler/HeaderIconHandler.js